import { Platform } from 'react-native';
import { sendVideoStartEventViaSDK } from './sdkVideoTracking';

type ServiceCategory = 'chat'|'coaching'|'games'|'gay'|'music'|'sexy'|'ringtones'|'sport'|'video'|'vod'|'youth'|'null';
type ServiceType = 'html'|'app';

export type DvProductCtx = {
  service_category: ServiceCategory;           // "video"
  rubric_id?: string | null;
  rubric_name?: string | null;
  content_id?: string | null;                  // episode_id
  content_name: string | null;                 // episode title (required by schema)
  service_id?: string | null;
  service_name?: string | null;                // "Hekaya"
  provider_name?: string | null;
  provider_id?: string | null;
  license_name?: string | null;
  license_id?: string | null;
  content_type?: string | null;
  service_type: ServiceType;                   // "html" (web) | "app" (native)
  campaign_id?: string | null;
  sales_mode?: string | null;
};

/**
 * Holds the latest dv_product values for the next consumption event.
 */
let _dvProductSnapshot: DvProductCtx | null = null;

/** Call before trackVidStart() - Non-blocking version using custom sender */
export async function setDvProductContext(input: {
  content_name: string;
  content_id?: string | null;
  campaign_id?: string | null;
}) {
  _dvProductSnapshot = {
    content_name: input.content_name ?? null,
    content_id: input.content_id ?? null,
    campaign_id: input.campaign_id ?? null,
    service_category: 'video',
    service_type: Platform.OS === 'web' ? 'html' : 'app',
    service_name: 'Hekaya'
  };
}

/** Optional: clear after we've fired one event */
export function clearDvProductContext() {
  _dvProductSnapshot = null;
}

// Generate a unique tracking ID for deduplication
function generateTrackingId(): string {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

let trackingCallCounter = 0;

/**
 * Fire the consumption event. No properties per schema.
 * Sends via Snowplow SDK for reliable session tracking.
 * Note: Video tracking is gated by analytics consent, which is checked during Snowplow initialization.
 * If analytics consent is granted, all Snowplow tracking (including video) is enabled.
 */
export async function trackVidStart() {
  const startTime = Date.now();
  const trackingId = generateTrackingId();
  const callNum = ++trackingCallCounter;
  const platformPrefix = Platform.OS === 'ios' ? '🍎 [iOS]' : '🤖 [Android]';


  if (!_dvProductSnapshot) {
    console.warn(`[snowplow][${Platform.OS}][video] ${platformPrefix} [TRACK-${callNum}] ⚠️ No product context available - cannot track without context`);
    return;
  }

  // Capture context before clearing
  const contextSnapshot = { ..._dvProductSnapshot };

  // Clear context immediately
  clearDvProductContext();

  // Send event using SDK method
  sendVideoStartEventViaSDK(contextSnapshot);

  const totalTime = Date.now() - startTime;
}